module.exports = __webpack_public_path__ + "img/pro_nine_4.ee61990f.jpg";